const applyWebViewerTheme = (iframeDoc) => {
    const vars = {
        '--document-background-color': '#f0f1f0',
        '--color-background-canvas': '#f0f1f0',
        '--color-overlay-canvas': '#f0f1f0',
        '--component-background': '#ffffff',
        '--panel-background': '#ffffff',
        '--tools-header-background': '#ffffff',
        '--view-header-background': '#ffffff',
        '--ribbons-background': '#ffffff',
        '--tools-overlay-background': '#ffffff',
        '--faded-component-background': '#ffffff',
        '--mobile-presets-background': '#ffffff',
        '--preset-background': '#ffffff',
        '--toggle-zoom-overlay-background': '#ffffff',
        '--text-color': '#001d00',
        '--icon-color': '#001d00',
        '--color-font-primary': '#001d00',
        '--color-font-secondary': '#001d00',
        '--color-theme-primary': '#43dcc9',
        '--color-theme-secondary': '#43dcc9',
        '--selected-icon-color': '#43dcc9',
        '--ribbon-active-color': '#43dcc9',
        '--outline-color': '#e6e0d4',
        '--list-separator-color': '#e6e0d4',
        '--scrollbar-color': '#e6e0d4',
    };
    Object.entries(vars).forEach(([key, value]) => {
        iframeDoc.documentElement.style.setProperty(key, value);
    });
};
export default applyWebViewerTheme;
